module.exports = __webpack_public_path__ + "img/4.9cb49d81.png";